var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.193,
    height: 11.881,
    viewBox: "0 0 12.193 11.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stop",
    d: "M9.652,0H2.54A2.511,2.511,0,0,0,0,2.475V9.406a2.511,2.511,0,0,0,2.54,2.475H9.652a2.511,2.511,0,0,0,2.54-2.475V2.475A2.511,2.511,0,0,0,9.652,0Zm1.524,9.406a1.5,1.5,0,0,1-1.524,1.485H2.54A1.5,1.5,0,0,1,1.016,9.406V2.475A1.5,1.5,0,0,1,2.54.99H9.652a1.5,1.5,0,0,1,1.524,1.485Z",
    fill: "#C70039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopProduct);
export default __webpack_public_path__ + "static/media/stopProduct.a4aebb7b017f6f8d203b0ea71de0ebb4.svg";
export { ForwardRef as ReactComponent };